/** HR hub entries; shared by the /hr page, its route guard and the sidebar link. */
import type { LucideIcon } from "lucide-react";
import {
  CalendarClock,
  ClipboardCheck,
  Coins,
  Fingerprint,
  Receipt,
  Settings,
  SlidersHorizontal,
  Users,
} from "lucide-react";
import { PERMISSIONS, type PermissionKey } from "@nova/shared";

export interface HrLink {
  key: string;
  to: string;
  icon: LucideIcon;
  permission: PermissionKey[];
}

export const SELF_LINKS: HrLink[] = [
  { key: "myAttendance", to: "/hr/me", icon: Fingerprint, permission: [PERMISSIONS.ATTENDANCE_SELF] },
  { key: "myPayslips", to: "/hr/me/payslips", icon: Receipt, permission: [PERMISSIONS.PAYROLL_VIEW_SELF] },
];

export const MANAGE_LINKS: HrLink[] = [
  { key: "employees", to: "/hr/employees", icon: Users, permission: [PERMISSIONS.HR_VIEW, PERMISSIONS.HR_MANAGE] },
  { key: "attendance", to: "/hr/attendance", icon: CalendarClock, permission: [PERMISSIONS.HR_VIEW, PERMISSIONS.ATTENDANCE_OVERRIDE] },
  { key: "requests", to: "/hr/requests", icon: ClipboardCheck, permission: [PERMISSIONS.LEAVE_APPROVE, PERMISSIONS.ATTENDANCE_OVERRIDE] },
  { key: "payroll", to: "/hr/payroll", icon: Coins, permission: [PERMISSIONS.PAYROLL_PREPARE, PERMISSIONS.PAYROLL_APPROVE, PERMISSIONS.PAYROLL_PAY] },
  { key: "adjustments", to: "/hr/payroll/adjustments", icon: SlidersHorizontal, permission: [PERMISSIONS.PAYROLL_PREPARE, PERMISSIONS.PAYROLL_APPROVE, PERMISSIONS.PAYROLL_PAY] },
  { key: "settings", to: "/hr/settings", icon: Settings, permission: [PERMISSIONS.HR_CONFIGURE] },
];

/** Any one of these opens the hub (and shows the sidebar link). */
export const HR_HUB_PERMISSIONS: PermissionKey[] = [
  ...new Set([...SELF_LINKS, ...MANAGE_LINKS].flatMap((l) => l.permission)),
];

